<template>
    <div class="loader">
        <div class="loader__inner">
            <Icon :height="size" :width="size">
                <IconLoop />
            </Icon>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue';
import IconLoop from '@/components/icons/IconLoop.vue';
export default {
    components: {
        Icon,
        IconLoop,
    },
    props: {
        size: {
            type: Number,
            default: 24,
        },
    },
};
</script>

<style lang="scss">
.loader {
    display: flex;
    line-height: 1;

    &__inner {
        display: flex;
        animation: spin 1000ms linear infinite;
    }
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
